import React, { Component } from 'react';
import axios from 'axios';



const API_KEY = "331a83a7b9af7db10dad960acfd5247f";


const Context = React.createContext();

export class Provider extends Component {
    state = {
        track_list: [],
        heading: 'Top 10 Tracks',
 
    };

    componentDidMount() {
        axios
          .get(
            `https://cors-anywhere.herokuapp.com/https://api.musixmatch.com/ws/1.1/chart.tracks.get?chart_name=top&page=1&page_size=10&country=us&f_has_lyrics=1&apikey=${API_KEY}`
          )
            .then((res) => {
              
              this.setState({
                  track_list: res.data.message.body.track_list,
              })
                console.log(this.track_list);
          })
          .catch((err) => console.log(err));
    }





    render() { 
        return ( 
            <Context.Provider value={this.state} >
                {this.props.children}
            </Context.Provider>
         );
    }
}
 
export const Consumer = Context.Consumer; 